import { defineStore } from 'pinia';

import { driverImApi } from '@/service/api/driver/im';
import { dialogueItemStatus } from '@/types';
import { queryURLParams } from '@/common/utils';
import { checkBridge, runBridge } from '@/common/jsBridgeUtils';

export const useDriverImStore = defineStore({
  id: 'driverIm',
  state: () => ({
    // 路由参数
    firstDialog: false,
    type: '',
    // session_id: '',
    // gvid: '',
    fleet_name: '',
    driver_name: '',

    messageCount: 0,

    msgList: [],
    user: {},
    receiver: {},
    interlocutor: {},
    dialogueList: [],
    dialogueDownList: [],
    dialogueTotal: 0,
    inviteId: '',
    inviteDetail: {}
  }),

  actions: {
    async getMsgByDialogueId(params: any) {
      const { data } = await driverImApi.getMsgByDialogueId(params);

      if (data) {
        this.msgList = data.list;
        this.receiver = data.receiver;
        this.user = data.user;
      }
      return data;
    },

    async getFleetMessageList(params: any) {
      try {
        const { data } = await driverImApi.getFleetMessageList(params);
        const list: any = [];
        const soonList: any = [];

        (data?.list || []).forEach((item: any) => {
          item?.sink_level === dialogueItemStatus.SINK ? soonList.push(item) : list.push(item);
        });
        this.dialogueList = list || [];
        this.dialogueDownList = soonList || [];
        this.dialogueTotal = data?.page_data?.total || 0;
      } catch (error) {
        console.log(error);
      }
    },
    async FleetUploadDialogue(params: any) {
      try {
        await driverImApi.FleetUploadDialogue(params);
      } catch (error) {
        console.log(error);
      }
    },

    async getNewMsgCount(params: any) {
      const { data } = await driverImApi.getNewMsgCount(params);

      this.messageCount = data?.count || 0;
    },
    async addDialogue(params: any) {
      const { data } = await driverImApi.addDialogue(params);

      return data;
    },

    async createRecommendInvite(params: any) {
      const query = queryURLParams(window.location.href);
      const phoneInfo: any = await new Promise(resolve => {
        if (checkBridge('getSystemInfo')) {
          runBridge('getSystemInfo', {}, (info: any) => {
            resolve(info);
          });
        } else {
          resolve(null);
        }
      });
      const { data } = await driverImApi.createRecommendInvite({
        ...params,
        user_agent: window.navigator.userAgent,
        lat: query.lat || 0,
        lng: query.lng || 0,
        model: phoneInfo?.model || (/(?:Android)/.test(navigator.userAgent) ? 'android' : 'iPhone')
      });

      this.inviteId = data.invite_id;
      return data;
    },
    async getInviteDetail(params: any) {
      const { data } = await driverImApi.getInviteDetail(params);

      this.inviteDetail = data || {};
    },
    async comfirmInvite(params: any) {
      const { data } = await driverImApi.ComfirmInvite(params);

      return data;
    },
    async getInviteStatus(params: any) {
      const { data } = await driverImApi.getInviteStatus(params);

      return data;
    }
  }
});
